module.exports = __webpack_public_path__ + "img/bg-level-up.14352124.png";